export default __webpack_public_path__ + "static/media/dollar.1d2ce49b.svg";